import { DateTime } from "luxon";
import { YearlessDate } from "../types";

export function convertStringToDate(
  v: string | null | undefined,
): DateTime | null | undefined {
  if (v === undefined || v === null) {
    return v;
  }
  const date = DateTime.fromISO(v, { setZone: true, zone: "utc" }).startOf(
    "day",
  );
  if (date.isValid) {
    return date;
  }
  return null;
}
export function validateDate({
  date,
  constraints,
}: {
  date: DateTime | null;
  constraints: {
    required?: boolean;
    unavailable?: {
      dates?: DateTime[];
      daysOfWeek?: number[];
    };
    minDate?: DateTime;
    maxDate?: DateTime;
  };
}) {
  const { required, unavailable, minDate, maxDate } = constraints;
  if (!date) {
    return required ? false : true;
  }
  if (unavailable?.dates?.some((d) => d.equals(date))) {
    return false;
  }
  if (unavailable?.daysOfWeek?.includes(date.weekday)) {
    return false;
  }
  if (minDate && date < minDate) {
    return false;
  }
  if (maxDate && date > maxDate) {
    return false;
  }
  return true;
}

export function validateYearlessDate({
  value,
  constraints,
}: {
  value: YearlessDate | null;
  constraints: {
    required?: boolean;
    unavailable?: {
      dates?: YearlessDate[];
    };
    minDate?: YearlessDate | null;
    maxDate?: YearlessDate | null;
  };
}): boolean {
  const { required, unavailable, minDate, maxDate } = constraints;
  if (!value || (!value?.day && !value?.month)) {
    return required ? false : true;
  }
  if (value.day === null || value.month === null) {
    return false;
  }
  if (
    unavailable?.dates?.some(
      (d) => d.day === value.day && d.month === value.month,
    )
  ) {
    return false;
  }
  const minDateMonth = minDate?.month ?? 1;
  const minDateDay = minDate?.day ?? 1;
  const maxDateMonth = maxDate?.month ?? 12;
  const maxDateDay = maxDate?.day ?? 31;
  if (
    value.month < minDateMonth || // Earlier month
    (value.month === minDateMonth && value.day < minDateDay) // Same month, earlier day
  ) {
    return false;
  }
  if (
    value.month > maxDateMonth || // Later month
    (value.month === maxDateMonth && value.day > maxDateDay) // Same month, later day
  ) {
    return false;
  }
  return true;
}
